// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11M1S","content":"styles_content__1Ud-j","row":"styles_row__9rz2D","footer":"styles_footer__3V99a","phraseLength":"styles_phraseLength___nTr-"};